import API from 'services/api';

export const deleteInvoice = ({ invoiceId }: { invoiceId: string }) =>
  API.delete(`/api/accommodation/calculations/invoices/${invoiceId}`);
